import Typography, { TypographyProps } from '@mui/material/Typography'
import Box, { BoxProps } from '@mui/material/Box'
import React from 'react'
import PriwallSvgIcon, { PriwallSvgIconProps } from '../atom/MpSvgIcon'

interface PriwallIconAndTextProps extends PriwallSvgIconProps {
  text: string
  textImageSpace: number
  typographyProps?: TypographyProps
  boxProps?: BoxProps
}
const PriwallIconAndText = (props: PriwallIconAndTextProps) => {
  const { text, typographyProps, textImageSpace, boxProps, ...otherProps } =
    props
  return (
    <Box display="flex" alignItems="center" {...boxProps}>
      <PriwallSvgIcon {...otherProps} />
      <Typography ml={`${textImageSpace}px`} sx={{color:"#ffffff"}}{...typographyProps}>
        {text}
      </Typography>
    </Box>
  )
}

export default PriwallIconAndText
